import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * FileEdit icon
 *
 * @category Files/Forms/Editing
 */
const FileEdit = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M9.34 28.01c1.47-1.449 3.43-3.328 5.64-5.508 2.52-2.73 4.839-4.07 6.328-6.859 1.98-4.219.603-4.612-3.249-2.92-2.22 1.12-3.28 2.84-5.379 4.7-1.95 1.9-4.269 4.17-6.089 5.939-1.65 1.39-2.12 2.68-.32 4.239 1.72 1.57 2.29 1.39 5.34 1.38h9.318c2.75.07 4.439.07 5.639-2.22.48-1.05.24-2.27.29-3.76-.01-4.548 0-10.897-.02-15.476.31-2.96-1.13-4.46-3.99-4.5-4.109-.05-8.228-.01-12.367-.02-1.99 0-4.34.49-5.02 2.66-.17.54-.2 1.11-.14 1.67.04 3.13-.11 11.228.04 14.327.28 1.16 1.03.69.96-.84.13-4.459-.3-11.138.16-15.057.94-1.94 2.28-1.79 4.64-1.77h11.077c1.8-.21 3.52.55 3.48 2.24.02 4.72-.02 11.708-.02 16.547 0 .96.11 1.96-.08 2.91-.21 1.05-.75 2.119-1.98 2.269m-4.39-14.755c.32-.1 1.846-.632 1.996-.482s-.44 1.32-.555 1.726-.395 1.474-.713 1.193-1.605-1.435-1.786-1.628-.232-.353 1.059-.809M7.802 27.751c-.68-.06-1.77-1.16-1.78-1.83-.01-.53.46-1.01.84-1.39 3.31-3.149 6.26-6.408 9.708-9.568 1.12-1.21 1.95.09 2.64 1 .19.35.19.6 0 .89-.8.88-2.28 2.28-4.1 4.12-2.099 2.059-4.608 4.638-6.558 6.458-.18.13-.4.29-.61.31h-.12z"
        />
        <path
          fill="currentColor"
          d="M8.561 8.105c4.28.24 10.458 0 14.717.08.68.07.71-1.06 0-1H8.911c-.45-.06-.69.52-.41.86zm.12 3.379c2.36.1 5.569 0 7.988.04.78 0 1.26.01 1.51-.01.17-.01.42-.2.41-.49 0-.23-.17-.42-.32-.46-1.49-.1-2.92 0-4.629-.04H8.89c-.479-.04-.679.69-.289.92l.08.05z"
        />
      </svg>
    );
  }
);

FileEdit.displayName = 'FileEdit';

export { FileEdit };
